import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fca79236"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full absolute top-0",
  id: "topbar"
}
const _hoisted_2 = { class: "structural-topbar flex justify-between align-center m-auto items-center w-5/6 lg:m-auto" }
const _hoisted_3 = { class: "logo-container my-4 relative right-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white sf-black text-3xl" }, "ARTIST", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InkLogo = _resolveComponent("InkLogo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VideoPlayerModal = _resolveComponent("VideoPlayerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "z-50 cursor-pointer flex items-center",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InkLogo, { class: "logo relative left-2" }),
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (_ctx.isShowVideo)
      ? (_openBlock(), _createBlock(_component_VideoPlayerModal, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowVideo=false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}